export default function createMemoizedFetch(fetch, options = {}) {
    const unresolvedPromises = new Map();
    const { generateCacheKey = (request) => `${request.method} ${request.url}` } = options;

    return function memoizedFetch(input, options) {
        const request = typeof input === 'string' ? new Request(input) : input;
        const cacheKey = generateCacheKey(request);

        if (unresolvedPromises.has(cacheKey)) {
            // Response body can only be read once so need to clone response to support multiple .json() calls
            return unresolvedPromises.get(cacheKey).then((response) => response.clone());
        }

        const promise = fetch(input, options);
        unresolvedPromises.set(cacheKey, promise);
        promise.catch(() => {}).then(() => unresolvedPromises.delete(cacheKey));
        return promise.then((response) => response.clone());
    };
}
